<template>
  <v-container fluid id="crm">
    <v-layout wrap justify-end>
      <v-flex xs12 class="text-sm-right">
        <template>
          <v-btn
            :loading="loadEx"
            v-if="$store.getters.getPackage != 'premium'"
            outline
            v-tooltip.top="'Unlock to PREMIUM plan'"
            color="grey"
            class="ma-0 mb-1"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
            <v-premium-lock></v-premium-lock>
          </v-btn>
          <v-btn
            :loading="loadEx"
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportDashboard"
            color="grey"
            outline
            class="ma-0 mb-1"
          >
            <em class="fas fa-file-export mr-1" />
            {{ $t('export') }}
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
    <date-filter @changeDate="getEp" :fullsize="false" v-model="selectedDate"></date-filter>
    <div class="mt-2">
      <multiselect
        v-model="selectEp"
        :options="ep"
        placeholder="Select Episode"
        @input="fetchDataChart"
      ></multiselect>
    </div>
    <div class="mb-5">
      <v-layout row right>
        <v-btn color="gray" outline @click="clearFilter">{{ $t('Clear Search') }}</v-btn>
      </v-layout>
    </div>
    <div class="mt-5">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="mainData"
        class="elevation-1"
        hide-actions
      >
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="(header, k) in props.headers"
              :key="header.text + k"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
                header.text === '' ? 'fix-column-width' : ''
              ]"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">
              {{
                props.item.first_name || props.item.last_name
                  ? `${props.item.first_name} ${props.item.last_name}`
                  : ''
              }}
            </td>
            <td class="text-xs-left">
              {{ props.item.vote ? props.item.vote : '-' }}
            </td>
            <td class="text-xs-left">{{ props.item.status || '-' }}</td>
            <td class="text-xs-left">
              {{ props.item.votetime ? formatDate(props.item.votetime) : '-' }}
            </td>
            <td class="text-xs-left fix-column-width">
              <v-btn
                color="primary"
                class="px-3"
                style="border-radius: 20px"
                @click="showUserHistoryVote(props.item.userid)"
                small
                >Voting record</v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <div
      v-if="totalData && Math.round(totalData / pagination.rowsPerPage)"
      class="my-3 flex-all-center"
    >
      <v-pagination
        @input="changePage"
        v-model="pagination.page"
        :length="Math.round(totalData / pagination.rowsPerPage)"
      ></v-pagination>
    </div>
    <v-dialog v-model="show" persistent width="950px">
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="show = false" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="pt-0 px-8">
          <h5>Voting Record</h5>
          <v-data-table
            :loading="loading"
            :headers="headersRecord"
            :items="voteHistory"
            class="elevation-1"
            :pagination.sync="pagination2"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="(header, k) in props.headers"
                  :key="header.text + k"
                  :class="[
                    'column sortable',
                    pagination2.descending ? 'desc' : 'asc',
                    header.value === pagination2.sortBy ? 'active' : ''
                  ]"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left">{{ formatDate(props.item.timestamp) || '-' }}</td>
                <td class="text-xs-left">{{ props.item.namespace || '-' }}</td>
                <td class="text-xs-left">{{ props.item.name || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import DateFilter from './TheNextFaceDateFilter'
import XLSX from 'xlsx'

export default {
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        descending: false,
        sortBy: 'name',
        rowsPerPage: 10
      },
      pagination2: {
        page: 1,
        descending: false,
        rowsPerPage: 500
      },
      offset: 0,
      ep: [],
      selectEp: '',
      filter: 'all',
      selectedDate: {
        start: null,
        end: null
      },
      loadEx: false,
      totalData: 0,
      mainData: [],
      headers: [
        { text: 'Name', value: 'name', align: 'center' },
        { text: 'Vote', value: 'vote', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Date', value: 'date', align: 'center' },
        { text: '', value: '', align: 'center', sortable: false, width: '1%' }
      ],
      headersRecord: [
        { text: 'Date', value: 'Date', align: 'center' },
        { text: 'Episode', value: 'Episode', align: 'center' },
        { text: 'Vote', value: 'Vote', align: 'center' }
      ],
      show: false,
      voteHistory: []
    }
  },
  components: { Multiselect, DateFilter },
  computed: {
    ...mapGetters(['selectedBot']),
    exportData() {
      let data = []
      this.mainData.forEach((ele) => {
        data.push({
          Episode: ele.namespace ? ele.namespace : '',
          Name: ele.first_name || ele.last_name ? `${ele.first_name} ${ele.last_name}` : '',
          Vote: ele.vote ? ele.vote : '',
          Status: ele.status,
          Date: ele.votetime ? this.formatDate(ele.votetime) : '',
          Time: ele.votetime ? this.formatTime(ele.votetime) : ''
        })
      })
      return data
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.getEp()
    },
    async fetchDataChart() {
      this.loading = true
      await this.getUserVoteByNamespace()
      this.loading = false
    },
    async showUserHistoryVote(userid) {
      this.loading = true
      await this.getVoteByUser(userid)
      this.loading = false
      this.show = true
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY')
      } else {
        return '-'
      }
    },
    formatTime(date) {
      if (date) {
        return moment(date).format('HH:mm')
      } else {
        return null
      }
    },
    changePage() {
      this.offset = this.pagination.page * this.pagination.rowsPerPage - this.pagination.rowsPerPage
      this.fetchDataChart()
    },
    async clearFilter() {
      this.selectedDate.start = null
      this.selectedDate.end = null
      this.selectEp = ''
      await this.getEp(false)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    formatExport(input) {
      let data = []
      input.forEach((ele) => {
        data.push({
          Episode: ele.namespace ? ele.namespace : '',
          Name: ele.first_name || ele.last_name ? `${ele.first_name} ${ele.last_name}` : '',
          Vote: ele.vote ? ele.vote : '',
          Status: ele.status,
          Date: ele.votetime ? this.formatDate(ele.votetime) : '',
          Time: ele.votetime ? this.formatTime(ele.votetime) : ''
        })
      })
      return data
    },
    async exportDashboard() {
      this.loadEx = true
      let dataEx = []
      let data = {
        pageid: this.selectedBot.pageid,
        namespace: 'all'
      }
      let res = await api.getUserVoteByNamespace(data)
      if (res) {
        dataEx = res.data
      }
      dataEx = this.formatExport(dataEx)
      this.loadEx = false
      if (dataEx.length) {
        let json = dataEx
        try {
          console.log(json)
          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'zwizdata-matrics.xlsx')
        } catch (error) {
          console.error(error)
        }
      }
    },
    async getEp(select = true) {
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end,
        app: this.filter
      }
      let res = await api.geteplist(data)
      if (res) {
        this.ep = res.length > 1 ? ['all', ...res] : res
        if (res.length > 0 && select) {
          this.selectEp = res[0]
          this.fetchDataChart()
        } else {
          this.selectEp = ''
          this.mainData = []
        }
      } else {
        this.ep = []
        this.selectEp = ''
        this.mainData = []
      }
    },
    async getUserVoteByNamespace() {
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end,
        namespace: this.selectEp,
        app: this.filter,
        limit: this.pagination.rowsPerPage,
        offset: this.offset
      }
      let res = await api.getUserVoteByNamespace(data)
      if (res) {
        this.mainData = res.data
        this.totalData = res.total
      } else {
        this.mainData = []
      }
    },
    async getVoteByUser(userid) {
      let data = {
        pageid: this.selectedBot.pageid,
        datefrom: this.selectedDate.start,
        dateto: this.selectedDate.end,
        namespace: this.selectEp,
        app: this.filter,
        userid
      }
      let res = await api.getVoteByUser(data)
      if (res) {
        this.voteHistory = res
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fix-column-width {
  width: 200px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/Participants.vue